__turbopack_context__.v({
  "container": "ProgressBar-module-scss-module__-4EgAa__container",
  "indeterminate": "ProgressBar-module-scss-module__-4EgAa__indeterminate",
  "indeterminate-animation": "ProgressBar-module-scss-module__-4EgAa__indeterminate-animation",
  "indeterminate-bar": "ProgressBar-module-scss-module__-4EgAa__indeterminate-bar",
  "transition": "ProgressBar-module-scss-module__-4EgAa__transition",
});
